'use es6';

export const isAcceptanceTest = () => {
  return !!window.navigator.webdriver;
};